import { render, staticRenderFns } from "./ProductPriceHistoryModal.vue?vue&type=template&id=ab405c74"
import script from "./ProductPriceHistoryModal.vue?vue&type=script&lang=js"
export * from "./ProductPriceHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports